import { client } from "../../../graphql";
import { getCustomOdeContents } from "./graphql";

export const getCustomOdeContentsService = async ({ batchId, companyId }) => {
  const result = await client.query({
    query: getCustomOdeContents,
    variables: {
      where: {
        ode: { id: companyId },
        batch: { id: batchId } },
      odeId: companyId
    },
    fetchPolicy: "network-only"
  });

  return result.data || [];
};
